import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'input', 'value', 'destroy'];

  connect () {
    this.toggleInputs();
  }

  toggleInputs () {
    this.containerTargets.forEach((container) => {
      if (container.dataset.fieldName === this.valueTarget.value || this.valueTarget.checked) {
        container.classList.remove('d-none');
      } else {
        container.classList.add('d-none');
      }
    });

    this.inputTargets.forEach((input) => {
      if (input.dataset.fieldName === this.valueTarget.value || this.valueTarget.checked) {
        input.removeAttribute('disabled');
      } else {
        input.setAttribute('disabled', 'disabled');
        input.value = '';
      }
    });

    if (this.hasDestroyTarget) {
      this.destroyTargets.forEach(target => {
        target.value = !this.valueTarget.checked;
      });
    }
  }
}
